<template>
    <div class="default-message">
        <div v-if="appData.selectedMenu == 'user'">
            <span v-html="$t('message.hint_menu_user1')"></span>
            <br>
            <hr class="hint-hr">
            <br>
            <table class="hint-table" align="center" >
                <tr>
                    <td class="hint-table-title" v-t="'message.item_layer'"></td>
                </tr>
                <tr>
                    <td class="hint-table-item" v-html="$t('message.hint_menu_user2')">
                    </td>
                </tr>
                <tr>
                    <td class="hint-table-title" v-t="'message.item_user'"></td>
                </tr>
                <tr>
                    <td class="hint-table-item" v-t="'message.hint_menu_user3'"></td>
                </tr>
                <tr>
                    <td class="hint-table-title" v-t="'message.item_group'"></td>
                </tr>
                <tr>
                    <td class="hint-table-item" v-html="$t('message.hint_menu_user4')">
                    </td>
                </tr>
            </table>
            <br>
            <table class="notice-table" align="center">
                <tr>
                    <td class="notice-table-title" v-t="'message.hint_menu_user5'"></td>
                </tr>
                <tr>
                    <td class="notice-table-item" v-html="$t('message.hint_menu_user6')">
                    </td>
                </tr>
            </table>
        </div>
        <div v-else-if="appData.selectedMenu == 'setting'" v-html="$t('message.hint_menu_setting')">
        </div>
        <div v-else-if="appData.selectedMenu == 'restrictions'" v-html="$t('message.hint_menu_restrictions')">
        </div>
    </div>
</template>

<script>

export default {
    data() {
      return {
      };
    },
    methods: {
    },
    components: {
    },
    props: ['appData']
}

</script>

<style scoped>
</style>
